import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux';
import { selectCanvasBluePrint } from 'store/canvas/selectors'
import muiThemable from 'material-ui/styles/muiThemeable'
import withStoreTheme from 'store/theme/withStoreTheme'
import withTheme from 'hocs/bases/withTheme';
import { routesByValue } from 'helpers/routesConstant'
import IconButton from 'material-ui/IconButton'
import SmartPhone from 'material-ui/svg-icons/hardware/smartphone'
import HorzSmartPhone from 'material-ui/svg-icons/hardware/tablet'
import Tablet from 'material-ui/svg-icons/hardware/tablet-mac'
import Desktop from 'material-ui/svg-icons/hardware/desktop-mac'
import FormSelect from 'components/forms/bases/FormSelect'
import Wrapper from 'components/wrappers/Wrapper'
import {
  Paper,
  ToolbarGroup,
  Toolbar,
} from 'material-ui';
import LanguageSwitcher from 'components/switches/LanguageSwitcher'
import withIntl from 'store/intl/withIntl'

class RenderPage extends Component {
  constructor(){
    super()
    this.state = {
      category: 'desktop',
      device: 'laptop13inch',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { previewPageId, currentLang, isCanvasPreviewerOpened } = this.props
    const {
      previewPageId: nextPreviewPageId,
      currentLang: nextCurrentLang,
      isCanvasPreviewerOpened: nextCanvasOpened,
      canvas,
    } = nextProps
    if (isCanvasPreviewerOpened !== nextCanvasOpened) {
      window.document.getElementById('preview').contentWindow.postMessage({
        isCanvasPreviewerOpened: nextCanvasOpened,
        canvas,
      }, '*')
    } else if (nextPreviewPageId && previewPageId !== nextPreviewPageId) {
      window.document.getElementById('preview').contentWindow.postMessage({ pageId: nextPreviewPageId }, '*')
    }
    if (currentLang !== nextCurrentLang) {
      window.document.getElementById('preview').contentWindow.switchLanguage(nextCurrentLang)
    }
  }

  render() {
    const { previewPageId, renderCloseButton, muiTheme } = this.props
    const { category, device } = this.state
    const screens = [
      { value: 'desktop', Component: Desktop },
      { value: 'tablet', Component: Tablet },
      { value: 'horizontalMobile', Component: HorzSmartPhone },
      { value: 'mobile', Component: SmartPhone },
    ]
    const categories = {
      desktop: [
        { label: 'Laptop 13"', value: 'laptop13inch' },
        // { label: 'Laptop 13"', value: 'laptop15inch' },
      ],
      tablet: [
        { label: 'iPad Pro', value: 'iPadPro' },
      ],
      horizontalMobile: [
        { label: 'iPhone 6 (Horizontal)', value: 'iPhone6Horizontal' },
      ],
      mobile: [
        { label: 'iPhone 6', value: 'iPhone6' },
      ],
    }
    const devices = {
      iPhone6: { width: 375 },
      iPhone6Horizontal: { width: 568 },
      iPadPro: { width: 800 },
      laptop13inch: { width: 1024 },
    }
    return (
      <div style={{ height: '100%' }}>
        <Toolbar style={{ height: 72 }}>
          <ToolbarGroup>
            <h3>{previewPageId}</h3>
          </ToolbarGroup>
          <ToolbarGroup>
            <Wrapper minWidth={'500px'} flex justifyContent={'space-around'}>
              <div>
                {screens.map(({ value, Component }) => (
                  <IconButton
                    key={value}
                    onClick={
                      () => this.setState({
                        category: value,
                        device: categories[value][0].value,
                      })
                    }
                  >
                    <Component color={value === category ? muiTheme.palette.accent1Color : ''} />
                  </IconButton>
                ))}
              </div>
              <FormSelect
                style={{ width: 250 }}
                options={categories[category]}
                value={device}
                onChange={(val) => this.setState({ device: val })}
              />
            </Wrapper>
          </ToolbarGroup>
          <ToolbarGroup>
            <LanguageSwitcher />
            {renderCloseButton()}
          </ToolbarGroup>
        </Toolbar>
        <div
          style={{
            width: '100%',
            height: 'calc(100% - 72px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Paper
            style={{
              // ...screens[this.state.selectedScreen],
              ...devices[device],
              transition: 'all 0.3s',
              height: '94%',
            }}
          >
            <iframe
              id={'preview'}
              style={{ borderWidth: 0 }}
              title="render"
              width="100%"
              height="100%"
              src={routesByValue.renderPage.value}
            />
          </Paper>
        </div>
      </div>
    )
  }
}

RenderPage.propTypes = {
  isCanvasPreviewerOpened: PropTypes.bool.isRequired,
  currentLang: PropTypes.string.isRequired,
  previewPageId: PropTypes.string,
  renderCloseButton: PropTypes.func,
  muiTheme: PropTypes.object,
  canvas: PropTypes.object.isRequired,
}

RenderPage.defaultProps = {
  previewPageId: null,
  renderCloseButton: () => null,
  muiTheme: {},
}

export default compose(
  withStoreTheme(),
  withTheme,
  withIntl(),
  muiThemable(),
  connect(
    (state) => ({
      canvas: selectCanvasBluePrint(state),
    }),
  ),
)(RenderPage);



// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/ViewPage.js